function UsersCtrl($scope, $timeout, $state, $controller, GeneralUtilsService, UserContextService, IconsService, FieldsService) {
	$controller('ConfigController', {$scope: $scope, $timeout: $timeout});

	var FieldTypes = FieldsService.getFieldTypes();

	function Roles(...singleNameRoles) {
		this.roles        = [];
		this.containsRole = roleName => this.roles.filter(role => role.name === roleName).length === 1;

		this.add = function (roleName, roleDisplayName) {
			const newRole = {"name" : roleName, "displayName" : roleDisplayName !== undefined ? roleDisplayName : roleName}
			this.roles.push(newRole);
			return newRole;
		}

		this.addIfNotExist = function addIfNotExist(roleName, roleDisplayName) {
			if (!this.containsRole(roleName)) { this.add(roleName, roleDisplayName); }
		};

		this.addNoDisplayRole = function addNoDisplayRole(roleName) {
			return this.add(roleName, "");
		}

		for (let nameInd = 0; nameInd < singleNameRoles.length; nameInd++) { this.addIfNotExist(singleNameRoles[nameInd]); }

		this.setCurrent = function setCurrent(roleName) {
			let matchingRole;
			let removeIndices = [];
			this.roles.forEach((role, ind) => {
				if (role.displayName === "") {
					removeIndices.push(ind);
				}
				if (role.name === roleName) {
					matchingRole = role;
				}
			});

			for (let removalInd of removeIndices) {
				this.roles.splice(removalInd, 1);
			}
			this.currentRole = matchingRole ? matchingRole : this.addNoDisplayRole(roleName);
		}
	}

	$scope.roles = new Roles(...Object.entries(UserContextService.getRoles()).map(role => role[0]));

	$scope.$root.$watch('accountType', function(newAccountType) {
		if (newAccountType && newAccountType == 'SYSTEM' && isSystemLogin && UserContextService.isEditor()) {
			$scope.roles.addIfNotExist("SUPER_USER");
		}
	});

	$scope.$watch('roles.currentRole', function(newRole, oldVal) {
		// propagate the role from the UI currentRole to the model user.role
		if (newRole) {
			$scope.user.role = newRole.name;
		}
	});

	$scope.datamodified = false;

	$scope.$root.hasChanges = function () {
		let user = $scope.user;
		if (!user) {
			return false;
		}
		if (user.id < 0) {
			return true;
		} // new user

		return !angular.equals($scope.user, $scope.orig);
	};

	$scope.tableConfig = {
		hasChanges: $scope.$root.hasChanges,
		noAutoCheckboxSelect: true,
		mode: 'list',

		statusNames: {
			DISABLED: 'Disabled',
			ACTIVE:   'Configured',
			LOCKED:   'Locked',
			NEW:      'New',
			PENDING_USER_CONFIGURATION: 'Invitation Sent'
		},

		accountId: $state.params.accountId,
		clientSideSearch: true,
		clientSideSort: true,
		dataURL: function () {
			return '/users?accountId=' + ($state.params.accountId || '');
		},
		titleSearch: 'Users',
		height: $scope.getContentHeight(),
		pageSize: -1,
		sortButton: true,
		afterUpdate: function () {
			$scope.$root.updateScroll('.pane.left .nano');
		},
		searchId: $state.params.id, // in case there is a search value in the URL params, use it to search
		addURL: function () {
			return '/showAddUser?inline=showAddUser&parent=users&accountId=' + $state.params.accountId;
		},
		fields: [{
			label: 'Name',
			path: 'name',
			template: "{{item.name + ((item.accountName) ? ' (' + item.accountName + ')' : '')}}"
		},
			{label: 'E-mail', path: 'email'},
			{
				label: 'Status',
				path: 'status',
				template: "<span><span ng-show='item.status == \"LOCKED\"' class='glyphicon glyphicon-lock error'></span> {{tableConfig.statusNames[item.status]}}</span>"
			},
			{label: 'Creation Date', path: 'creationDate'},
			{label: 'Last Modified', path: 'lastModified'},
		],
		type: 'Admin',
		addAction: function () {
			$scope.existingResellerAdminsCollection();
			$scope.newUser = {id: GeneralUtilsService.getRandomId(), name: '', role: "VIEWER", status: 'NEW'};
			$scope.$root.openPopup('addUserDlg');
		},
		actions: ['remove'],
		processData: function (items) {
			if (items && items.length > 0) {
				setStatusAndCaption(items);
			}
		},
		onSelect: function (index) {
			store.fetch({
				path: '/show?type=admin&adminId=' + $scope.tableConfig.items[index].id,
				success: function (data) {
					if (!$scope.loaded) {
						return;
					}

					$timeout(function () {
						$scope.$root.clearErrors();
						$scope.user = data;
						$scope.roles.setCurrent(data.role);
						$scope.user.disableEditing = $state.params.accountId !== data.adminAccountId;
						$scope.orig = angular.copy($scope.user);
						$scope.updateRightScroll();
					}, 0);
				},
			});
		},
		specialActions: [{
			func: function (selectedItems) {
				$scope.disable(selectedItems, 'Admin');
			},
			icon: 'disable',
			tooltip: 'Disable Users'
		}, {
			func: function (selectedItems) {
				$scope.disable(selectedItems, 'Admin', true);
			},
			icon: 'enable',
			tooltip: 'Enable Users'
		}, {
			func: function (selectedItems) {
				$scope.resendInvitations(selectedItems, 'Admin');
			},
			icon: 'password',
			tooltip: 'Resend invitations'
		}, {
			func: function (selectedItems) {
				$scope.resetPassword(selectedItems, 'Admin', 'password');
			},
			icon: 'password',
			tooltip: 'Reset Passwords'
		}],
	};


	if (isSystemLogin) {
		$scope.tableConfig.specialActions.push({
			func: function (selectedItems) {
				$scope.moveAdmin(selectedItems, 'Admin');
			},
			icon: 'transfer',
			tooltip: 'Move Admins to Reseller'
		});
	}

	// Add option to reset secret of 2 factor auth
	$scope.tableConfig.specialActions.push({
			func: function (selectedItems) {
				$scope.resetPassword(selectedItems, 'Admin', 'secret');
			},
			icon: 'qrcode',
			tooltip: 'Reset 2 Factor Authentication',
		}
	);

	if (isSystemLogin && UserContextService.isEditor() && $scope.$root.accountType === 'SYSTEM') {
		$scope.tableConfig.specialActions.push({
			func: function (selectedItems) {
				$scope.resetPassword(selectedItems, 'Admin', 'permission-elevation-secret');
			},
			icon: 'qrcode',
			tooltip: 'Reset Permission Elevation Code'
		});
	}

	function setStatusAndCaption(items, set, setTo) {
		items.forEach(function (item) {
			if (set) {
				item.isActive = setTo;
			} else {
				item.isActive = (item.status === 'ACTIVE');
			}
			item.caption = item.name + ((item.accountName) ? ' (' + item.accountName + ')' : '');
		});
	}

	$scope.saveChanges = function () {
		$scope.user.newSaveMethod = true;
		$scope.loading = true;
		store.save({
			path: '/edit',
			data: $scope.user,
			dataObj: 'json',
			queryParams: {adminId: $scope.user.id, save: true, accountId: $state.params.accountId},
			success: function (data) {
				$timeout(function () {
					$scope.loading = false;
				}, 0);
				$scope.$root.handleServerResponse(data, 'user', 'Admin saved successfully');
				if (data.status !== 'ERROR') {
					$scope.reLoadUser(data.model);
				}
			}
		});
	};

	$scope.reLoadUser = function (data) {
		$scope.user = data;
		$scope.orig = angular.copy($scope.user);
		$scope.tableConfig.selectedId = data.id;
		let i;
		for (i = 0; $scope.tableConfig.items[i]; i++) {
			if ($scope.tableConfig.items[i].id === data.id) {
				break;
			}
		}

		$scope.tableConfig.items[i] = data;
	};

	$scope.isSystemAdmin = function () {
		return UserContextService.isEditor() && UserContextService.isSystemLogin();
	};


	$scope.addUser = function () {
		$scope.loadingSaveNew = true;
		var params;
		if ($scope.newUser.existingAdmin) {
			params = {
				accountId: $state.params.accountId,
				adminId: $scope.newUser.selectedUser.id,
				type: 'Admin',
				save: true
			};
			store.save({
				path: '/addAdminToAccount',
				queryParams: params,
				success: function (data) {
					$scope.loadingSaveNew = false;
					$scope.$root.handleServerResponse(data, 'newUser', 'Admin added successfully');
					if (data.status !== 'ERROR') {
						$scope.tableConfig.selectedId = data.id;
						$scope.datamodified = new Date().getTime();
						$scope.closePopup('addUserDlg');
					}
				},
			});
		} else {
			delete $scope.newUser.selectedUser;
			params = {accountId: $state.params.accountId, type: 'Admin', save: true};
			store.save({
				path: '/add',
				data: $scope.newUser,
				dataObj: 'json',
				queryParams: params,
				success: function (data) {
					$scope.loadingSaveNew = false;
					$scope.$root.handleServerResponse(data, 'newUser', 'Admin added successfully, invitation sent');
					if (data.status !== 'ERROR') {
						$scope.tableConfig.selectedId = data.model.id;
						$scope.datamodified = new Date().getTime();
						$scope.closePopup('addUserDlg');
					}
				},
			});
		}
	};


	$scope.resetPassword = function (selectedItems, type, resetType) {
		var items = [];
		var nameList = [];
		selectedItems.forEach(function (item) {
			items.push(item.id);
			nameList.push(item.name);
		});
		var data = {items: items, type: type, accountId: $state.params.accountId};
		var len = selectedItems.length;
		if (len === 0) {
			$scope.$root.alert('Please select admins');
			return;
		}

		var itemsMessage = (len === 1 ? 'to one admin: ' : 'to ' + len + ' selected admins: ') + nameList.join(', ');
		$scope.$root.confirm('Are you sure you want to reset ' + (resetType === 'secret' || resetType === 'permission-elevation-secret' ? 'secret ' : 'password ') + itemsMessage + '?', function () {
			store.action({
				path: resetType === 'secret' ? 'resetSecrets' : (resetType === 'permission-elevation-secret' ? 'resetPermissionElevationSecret' : 'resetPasswords'),
				data: data,
				dataObj: 'json',
				success: function (returnedData) {
					$scope.$root.handleServerResponse(returnedData, '', (resetType === 'secret' || resetType === 'permission-elevation-secret' ? 'Secrets' : 'Passwords') + ' were reset and invitations were send to the admins', null, true);
				},
			});
		});
	};

	$scope.moveAdmin = function (selectedItems, type) {
		if (selectedItems.length === 0) {
			$scope.$root.alert('Please select admins');
			return;
		}
		var items = [];
		selectedItems.forEach(function (item) {
			items.push(item.id);
		});
		var data = {items: items, type: type};
		let adminsNames = selectedItems.map(x => x.name);
		let adminsTitle = "admin"
		if (adminsNames.length > 1) {
			adminsNames = adminsNames.join(", ");
			adminsTitle += "s"
		}

		$scope.$root.confirm("You're about to move " + adminsTitle + ' "' + adminsNames + '" to a Reseller account. Do you want to continue?', function () {
			store.action({
				path: '/moveAdmin?accountId=' + $state.params.accountId,
				data: data,
				dataObj: 'json',
				success: function (returnedData) {
					$scope.$root.handleServerResponse(returnedData, 'user', 'Selected admins moved successfully to reseller');
					if (data.status !== 'ERROR') {
						for (const item of data.items) {
							for (var userKey in $scope.tableConfig.items) {
								var user = $scope.tableConfig.items[userKey];
								if (item.id === user.id) {
									$scope.tableConfig.items[userKey] = item;
								}
							}
						}
						$scope.datamodified = new Date().getTime();
					}
				},
			});
		})
	}

	$scope.resendInvitations = function (selectedItems, type) {
		var items = [];
		var nameList = [];
		selectedItems.forEach(function (item) {
			items.push(item.id);
			nameList.push(item.name);
		});
		var data = {items: items, type: type};
		var len = selectedItems.length;
		if (len === 0) {
			$scope.$root.alert('Please select users');
			return;
		}
		var itemsMessage = (len === 1 ? 'invitation to one admin: ' : len + ' invitations to selected admins: ') + nameList.join(', ');
		$scope.$root.confirm('Are you sure you want to resend ' + itemsMessage + '?', function () {
			store.action({
				path: 'resendMail',
				data: data,
				dataObj: 'json',
				success: function (returnedData) {
					$scope.$root.handleServerResponse(returnedData, '', 'Invitations were send to the selected admins', null, true);
				},
			});
		});
	};

	$scope.unLock = function () {
		$scope.$root.confirm('Are you sure you want to unlock admin ' + $scope.user.firstName + '  ' + $scope.user.lastName + ' ?', function () {
			store.action({
				path: 'unlockAdmin',
				queryParams: {adminId: $scope.user.id},
				success: function (data) {
					$scope.$root.handleServerResponse(data, '', 'Admin is unlocked');
					if (data.status !== 'ERROR') {
						$scope.reLoadUser(data);
					}
				},
			});
		});
	};

	$scope.existingResellerAdminsCollection = function (state, params) {
		store.fetch({
			path: '/existingResellerAdmins?accountId=' + $state.params.accountId,
			success: function (data) {
				$scope.existingResellerAdmins = data.items;
			},
		});
	};

	$timeout(function () {
		const $headings = $('#configPage').find('.accordion-heading');
		if ($headings.length === 1) {
			$headings.first().click();
		}
	}, 1, false);

	$scope.icons = IconsService.getIcons();

	store.fetch({
		path: "/getAllSites",
		method: 'POST',
		data: { dateField: '', from: 0, limit: -1 },
		dataObj: 'dataConfig',
		queryParams: {'accountId' :  ($state.params.accountId ? $state.params.accountId : "")},
	});

	$scope.$root.$watch('accountType', () => {
		if ($scope.$root.accountType === 'REGULAR') {
			$scope.roles.addIfNotExist("SITES_VIEWER", "REGIONAL_VIEWER");
		}
	});

	$scope.allowedItemsFields = {
		name: 'Permitted Items',
		id: 'allowedItems',
		types: [{
			name: 'Groups',
			field: FieldTypes.groups
		}, {
			name: 'Sites',
			field: FieldTypes.sites
		}]
	}

}
